
























































































































































































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import { ApiResponse, ClientData } from '@/interfaces'
import { mapState } from 'vuex'

export default Vue.extend({
  components: { Nav },
  data() {
    return {
      busy: false,
      clientData: {
        name: null,
        reference: null,
        licenceExpirationDate: null,
        diskQuota: null,
        emailQuota: null,
        yousignSent: null,
        yousignQuota: null,
        aiRequest: null,
        aiQuota: null,
        addons: null,
        stockIdFormat: null,
      } as ClientData,
      autocompleteNone: 'none',
      changeDetected: null as null | boolean,
      suspendCreditAutomatism: false,
    }
  },
  computed: {
    ...mapState(['user', 'connectedAs']),
    isExeveAdmin(): boolean {
      return this.user !== null && (!!this.user.isAdmin || this.connectedAs !== null)
    },
    addonOptions(): { value: number; label: string }[] {
      // Liste exhaustive des 41 bits d'addons (valeur = 2^(n-1)), pour rétro-compatibilité
      const definitions: { value: number; label: string | null }[] = [
        { value: 1, label: 'Téléchargement de factures en masse' },
        { value: 2, label: null },
        { value: 4, label: null },
        { value: 8, label: null },
        { value: 16, label: null },
        { value: 32, label: 'Modèle de facture par vente' },
        { value: 64, label: null },
        { value: 128, label: 'Contacts Liés (JUD)' },
        { value: 256, label: 'ADAGP : Droits de suite, génération du document' },
        { value: 512, label: null },
        { value: 1024, label: 'SIV sur les inventaires' },
        { value: 2048, label: null },
        { value: 4096, label: 'Notes sur les contacts' },
        { value: 8192, label: null },
        { value: 16384, label: 'Fiche véhicule vente / état des lieux' },
        { value: 32768, label: "Dupliquer l'inventaire (JUD)" },
        {
          value: 65536,
          label:
            'Champs complémentaires sur les inventaires (judiciaires) + Description complémentaire sur les lots d\'inventaire',
        },
        { value: 131072, label: 'Signature au doigt' },
        { value: 262144, label: 'Bilan comptable' },
        { value: 524288, label: 'Modification du Nom du dossier + N° Contact' },
        { value: 1048576, label: "Fusion des lots d'inventaire" },
        { value: 2097152, label: null },
        { value: 4194304, label: null },
        { value: 8388608, label: 'Exports spécifiques (Ciel + RV)' },
        { value: 16777216, label: 'Génération de documents (BL) depuis le bordereau' },
        { value: 33554432, label: null },
        { value: 67108864, label: null },
        { value: 134217728, label: null },
        { value: 268435456, label: null },
        { value: 536870912, label: 'Plateformes de publication multiples' },
        {
          value: 1073741824,
          label: 'Documents : envois et suppressions multiples + documents avancés (filtres et notes)',
        },
        {
          value: 2147483648,
          label: "Contacts : Filtre sur les acheteur d'une vente et affectation des cibles",
        },
        { value: 4294967296, label: null },
        { value: 8589934592, label: null },
        { value: 17179869184, label: null },
        { value: 34359738368, label: 'Description détaillée du lot pour le référencement' },
        { value: 68719476736, label: 'Mailing aux acheteurs' },
        { value: 137438953472, label: 'Reserve NET' },
        { value: 274877906944, label: 'Récapitulatif chiffré de la vente' },
        { value: 549755813888, label: 'Numérotation de la vente par rubrique' },
        {
          value: 1099511627776,
          label: "Ajout en masse d'un texte à la fin de la description des lots sélectionnés",
        },
      ]
      // Numéro de l'addon (1 à 41) déduit de sa valeur (2^(n-1))
      return definitions.map((addon) => {
        const number = Math.round(Math.log2(addon.value)) + 1
        return { value: addon.value, label: `#${number} ${addon.label ?? 'libre'}` }
      })
    },
    selectedAddons: {
      get(): number[] {
        const mask = Number(this.clientData.addons ?? 0)
        if (!mask) {
          return []
        }
        // Évite les opérateurs bit à bit (limités à 32 bits en JS) pour les valeurs > 2^31
        return this.addonOptions
          .filter((addon) => Math.floor(mask / addon.value) % 2 === 1)
          .map((addon) => addon.value)
      },
      set(values: number[]) {
        this.clientData.addons = values.reduce((sum, value) => sum + value, 0)
      },
    },
  },
  watch: {
    user(newVal) {
      if (newVal?.client?.id) {
        this.fetchClient(newVal.client.id)
      }
    },
    clientData: {
      deep: true,
      immediate: true,
      handler() {
        if (this.changeDetected === false) {
          this.changeDetected = true
        }
      },
    },
    'clientData.yousignQuota'(newVal, oldVal) {
      this.adjustCredit('yousignSent', newVal, oldVal)
    },
    'clientData.aiQuota'(newVal, oldVal) {
      this.adjustCredit('aiRequest', newVal, oldVal)
    },
  },
  mounted() {
    if (this.user?.client?.id) {
      this.fetchClient(this.user.client.id)
    }
    this.$nextTick(() => {
      this.changeDetected = false
    })
  },
  methods: {
    setAttribute() {
      this.autocompleteNone = 'none'
    },
    // Répercute automatiquement une variation de quota sur le crédit associé
    adjustCredit(creditField: 'yousignSent' | 'aiRequest', newVal: unknown, oldVal: unknown) {
      if (this.suspendCreditAutomatism) {
        return
      }
      const diff = Number(newVal ?? 0) - Number(oldVal ?? 0)
      if (!diff) {
        return
      }
      this.clientData[creditField] = Number(this.clientData[creditField] ?? 0) + diff
    },
    cancelForm() {
      this.$router.back()
    },
    goBack() {
      this.$router.back()
    },
    fetchClient(clientId: number) {
      this.busy = true
      this.$api
        .get(`/client/${clientId}`)
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          this.suspendCreditAutomatism = true
          this.clientData = apiResponse.data
          this.$nextTick(() => {
            this.suspendCreditAutomatism = false
          })
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Impossible de charger les informations du client.',
          })
        })
        .finally(() => {
          this.busy = false
          this.$nextTick(() => {
            this.changeDetected = false
          })
        })
    },
    submit() {
      if (!this.user?.client?.id) {
        return
      }
      this.busy = true
      const loading = this.$loading({
        target: '.form-panel',
        text: 'Chargement des données...',
      })
      this.$api
        .put(`/client/${this.user.client.id}`, this.clientData)
        .then((response) => {
          const apiResponse = response.data

          this.suspendCreditAutomatism = true
          this.clientData = apiResponse.data
          this.$nextTick(() => {
            this.suspendCreditAutomatism = false
          })
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: 'Client modifié avec succès !',
          })
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
        .finally(() => {
          this.busy = false
          this.changeDetected = false
          loading.close()
        })
    },
  },
})
